import Vue from "vue";
import { i18n } from "../main";
import ReviewsCategoriesHeatmapTooltip from "@/components/Reviews/Categories/ReviewsCategoriesHeatmapTooltip.vue";

export const getChartOptions = (data, color) => {
  return {
    color,
    tooltip: {
      className: "chart-tooltip",
      backgroundColor: "rgba(54, 60, 86, 0.9)",
      padding: 14,
      textStyle: {
        color: "white"
      },
      borderWidth: 0,
      confine: true,
      formatter: tooltipFormatter
    },
    series: [
      {
        breadcrumb: { show: false },
        colorMappingBy: "value",
        type: "treemap",
        visualDimension: 1,
        nodeClick: false,
        roam: false,
        height: "100%",
        width: "100%",
        label: {
          fontWeight: "700",
          fontSize: "16px",
          formatter: labelFormatter,
          overflow: "truncate",
          ellipsis: "..."
        },
        data,
        visualMin: -100,
        visualMax: 100
      }
    ]
  };
};

const labelFormatter = ({ name }) => {
  return `${name || i18n.t("message.common.reviewsWithoutCategory")}`;
};

const tooltipFormatter = ({ data }) => {
  const ComponentClass = Vue.extend(ReviewsCategoriesHeatmapTooltip);
  const instance = new ComponentClass({
    i18n,
    propsData: { data }
  });
  instance.$mount();
  return instance.$el.outerHTML;
};
